var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"800px","width":"100%","position":"relative","background-color":"#F3F3F5","overflow":"scroll"},attrs:{"id":"eventdaily"}},[_c('h3',[_vm._v("24H内告警走势图")]),_c('div',{ref:"mychart",staticClass:"myChart",staticStyle:{"background-color":"red"}}),_c('div',{staticClass:"myChart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }